import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';
import Icon from '../icon';

interface IFabProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 按钮大小
   * @default normal
   */
  size?: 'normal' | 'small';
  /**
   * 图标名称或图片链接
   */
  icon?: string;
  /**
   * 点击按钮时的回调
   */
  onClick?: () => void;
}

const Fab: FC<PropsWithChildren<IFabProps>> = ({ children, className = '', size = 'normal', icon, onClick }) => {
  const rootClass = classNames('ink-fab', className, {
    [`ink-fab--${size}`]: size,
  });
  return (
    <View className={rootClass} onClick={onClick}>
      {icon && <Icon className="ink-fab__icon" name={icon} />}
      {children}
    </View>
  );
};

export default Fab;
